import { Variables } from 'graphql-request';
import { getConfig } from '../graphql';
import { getGraphqlRequestClient } from '../graphql/clients';
import { useAuth0 } from '../provider';

export const useFetcher = <TData, TVariables extends Variables | undefined>(
  query: string,
  options?: RequestInit['headers'],
): ((variables?: TVariables) => Promise<TData>) => {
  const { getAccessTokenSilently } = useAuth0();

  const client = getGraphqlRequestClient(getConfig().url, {
    headers: options,
  });

  return async (variables?: TVariables) => {
    const credentials = await getAccessTokenSilently();

    if (credentials && 'accessToken' in credentials) {
      client.setHeader('Authorization', `Bearer ${credentials?.accessToken}`);
    }

    if (credentials && 'status' in credentials && credentials.status === 'TOKEN_ERROR') {
      return Promise.reject(credentials);
    }
    return client.request(query, variables);
  };
};
